<div class="border border-outline dark:border-outline-darkmode rounded-md">
  <div class="py-5 px-6 flex gap-2 items-center">
    <ng-content select="[slot=header-start]" />
    <h2 class="flex-1 font-semibold leading-6 line-clamp-1">
      <ng-content select="[slot=header-title]" />
    </h2>
    <ng-content select="[slot=header-end]" />
  </div>
  <div class="p-6 empty:hidden border-t border-outline dark:border-outline-darkmode">
    <ng-content />
  </div>
  <div class="pb-4 px-6 empty:hidden">
    <ng-content select="[slot=footer]" />
  </div>
</div>
